import React from 'react';

import Layout from 'layouts/Layout';
import AggridNew from './AggridNew';

const AggridLayout = () => <Layout component={AggridNew} hasGrid />;

export default AggridLayout;
